import {
    UPDATE_MENU
} from '../actions/menu-action';

export default function menuReducer(state = '', {
    type,
    payload
}) {    
    switch (type) {
        case UPDATE_MENU:
            return payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/container/reducers/menu-reducer.js